<template>
  <div id="app" :class="isDeathGray ? 'death-gray' : ''" >
    <router-view/>
  </div>
</template>

<script>
  import {getLoginToken, setLoginToken, setUserInfo} from './cache/Cache'
  import store from "@/store";
  export default {
    watch: {
      $route: {
        handler() {
          let xc_sso_sessionid = this.$route.query.xc_sso_sessionid;
          //深度监听，同时也可监听到param参数变化
          if (xc_sso_sessionid) {
            global.loginToken = xc_sso_sessionid
            setLoginToken(xc_sso_sessionid)
          }
        },
        deep: true,
      }
    },
    mounted(){
    },
    data() {
      return {
        isDeathGray:false,
      };
    },
    computed: {},

    methods: {
    }
  };
</script>

<style lang="less">
  @import './app.less';

</style>
